export default () => {
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    $( document ).on( 'jet-filter-content-rendered', function() {
        removeLoadingResources();
    });

    $( document ).ready(function() {
        $('.hero-leaves').addClass('anim');
        setTimeout(()=>{
            $('.hero-leaves').addClass('no-anim');
        }, 3000)
    });

    if(getUrlParameter('resources-categories')){
        const filter = document.querySelectorAll('.jet-radio-list__input[value="'+getUrlParameter('resources-categories')+'"]');
        if(filter && filter[0]) {
            setTimeout(() => {
                filter[0].click();
            }, 200);
        }
    }else{
        removeLoadingResources();
    }

    function removeLoadingResources(){
        document.querySelectorAll('.jet-listing-grid--blocks').forEach(function(element) {
            element.classList.remove('resources-listing');
        });
    }

};

